import React from 'react';
import Navigation from '../components/shared/Navigation';
import Footer from '../components/shared/Footer';

export default function TermsPage() {
  return (
    <div>
      <Navigation />
      
      <div className="container py-24 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-[var(--font-display)] tracking-[-0.02em] mb-4">
          Terms of Service
        </h1>
        <p className="text-sm text-muted-foreground mb-12">
          Last Updated: January 2026
        </p>

        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-[var(--font-display)] mb-4">1. Acceptance of Terms</h2>
            <p className="text-muted-foreground leading-relaxed">
              By accessing and using the Ellis Row website ("Site"), you accept and agree to be bound by these Terms of Service. 
              Ellis Row is a development project owned and operated by Mods Enterprises. If you do not agree to these terms, 
              please do not use this Site.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-[var(--font-display)] mb-4">2. Application Fees and Deposits</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              <strong>Application Fee ($100):</strong> The application fee is non-refundable and covers the cost of background checks, 
              credit reports, and application processing. Payment of the application fee does not guarantee approval or availability of a unit.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              <strong>Reservation Deposit ($250):</strong> The reservation deposit is non-refundable and secures your place in line 
              for a specific unit. This deposit will be applied toward your first month's rent or purchase down payment upon lease 
              signing or purchase agreement execution. Deposits are forfeited if you do not proceed with the lease or purchase.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-[var(--font-display)] mb-4">3. Property Availability</h2>
            <p className="text-muted-foreground leading-relaxed">
              All units are subject to availability. Ellis Row is currently under development with an expected completion date of 
              Fall/Winter 2026. Construction timelines are estimates and may change. Mods Enterprises reserves the right to modify 
              specifications, features, and pricing without notice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-[var(--font-display)] mb-4">4. Application Process</h2>
            <p className="text-muted-foreground leading-relaxed">
              All applicants must complete the application process and meet our qualifying criteria, which includes but is not limited to 
              credit checks, income verification, rental history, and background checks. Approval is at the sole discretion of Mods Enterprises.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-[var(--font-display)] mb-4">5. Payment Processing</h2>
            <p className="text-muted-foreground leading-relaxed">
              All payments are processed securely through Stripe. By submitting payment information, you authorize Mods Enterprises 
              to charge your payment method for the specified amounts. You are responsible for ensuring your payment information is 
              accurate and up to date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-[var(--font-display)] mb-4">6. Furnished Unit Options</h2>
            <p className="text-muted-foreground leading-relaxed">
              Rental units are available furnished or unfurnished. Furnished units are provided with designer furniture packages at 
              an additional monthly cost. Furniture remains the property of Mods Enterprises and must be maintained in good condition.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-[var(--font-display)] mb-4">7. Limitation of Liability</h2>
            <p className="text-muted-foreground leading-relaxed">
              Mods Enterprises shall not be liable for any delays in construction, changes to specifications, or unavailability of units. 
              Images and renderings shown on this Site are for illustrative purposes only and may not reflect the final product.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-[var(--font-display)] mb-4">8. Fair Housing</h2>
            <p className="text-muted-foreground leading-relaxed">
              Ellis Row complies with all federal, state, and local fair housing laws. We do not discriminate on the basis of race, 
              color, national origin, religion, sex, familial status, disability, or any other protected class.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-[var(--font-display)] mb-4">9. Privacy</h2>
            <p className="text-muted-foreground leading-relaxed">
              Your use of this Site is also governed by our Privacy Policy. By using the Site, you consent to the collection and use 
              of your information as described in the Privacy Policy.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-[var(--font-display)] mb-4">10. Changes to Terms</h2>
            <p className="text-muted-foreground leading-relaxed">
              Mods Enterprises reserves the right to modify these Terms of Service at any time. Continued use of the Site following 
              any changes constitutes acceptance of the modified terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-[var(--font-display)] mb-4">11. Contact Information</h2>
            <p className="text-muted-foreground leading-relaxed">
              For questions regarding these Terms of Service, please contact us at info@liveellisrow.com.
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}
